"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripeSdk = void 0;
var tslib_1 = require("tslib");
var pure_1 = require("@stripe/stripe-js/pure");
pure_1.loadStripe.setLoadParameters({ advancedFraudSignals: false });
var stripe = null;
var stripeSdk = function () {
    return stripe;
};
exports.stripeSdk = stripeSdk;
exports.stripeSdk.init = function (_a) { return tslib_1.__awaiter(void 0, [_a], void 0, function (_b) {
    var stripeId = _b.stripeId;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, (0, pure_1.loadStripe)(stripeId)];
            case 1:
                stripe = _c.sent();
                return [2 /*return*/, stripe];
        }
    });
}); };
